import { combineReducers } from 'redux'
import { createAction, createReducer} from 'typesafe-actions'
import { payloadReducer } from '../../../utils/redux-utils'
import {Brand, ClientWithBrands, DirectionWithDepartments, TaskType} from '../../../responses/refs/refs'
import {Departments} from '../../../responses/departments'
import {User} from '../../../responses/users'
import {WorkObject} from '../../../responses/objects'
import {ID} from '../../../types/UtilityTypes'

export type DepartmentTasksFilters = {
    department?: ID[],
    user?: ID[],
    direction?: ID[],
    client?:ID[],
    brand?:ID[],
    work_object?: ID[],
    tasks_type?: ID[]
}

export const taskFiltersActions = {
    setDepartments: createAction('@TASK_FILTERS/SET_DEPARTMENTS')<Departments[]>(),
    setUsers: createAction('@TASK_FILTERS/SET_USERS')<User[]>(),
    setDirections: createAction('@TASK_FILTERS/SET_DIRECTIONS')<DirectionWithDepartments[]>(),
    setClients: createAction('@TASK_FILTERS/SET_CLIENTS')<ClientWithBrands[]>(),
    setBrands: createAction('@TASK_FILTERS/SET_BRANDS')<Brand[]>(),
    setWorkObjects: createAction('@TASK_FILTERS/SET_WORK_OBJECT')<WorkObject[]>(),
    setTasksType: createAction('@TASK_FILTERS/SET_TASKS_TYPE')<TaskType[]>(),
    clearFilters: createAction('@TASK_FILTERS/CLEAR_FILTERS')(),
}

export interface TaskFiltersState {
    department: Departments[],
    user: User[],
    direction: DirectionWithDepartments[],
    client: ClientWithBrands[],
    brand: Brand[],
    work_object: WorkObject[],
    tasks_type: TaskType[],
}

export const taskFiltersReducer = combineReducers<TaskFiltersState>({
    department: createReducer<Departments[]>([])
        .handleAction(taskFiltersActions.setDepartments, payloadReducer)
        .handleAction(taskFiltersActions.clearFilters, () =>[]),
    user: createReducer<User[]>([])
        .handleAction(taskFiltersActions.setUsers, payloadReducer)
        .handleAction(taskFiltersActions.clearFilters, () =>[]),
    direction: createReducer<DirectionWithDepartments[]>([])
        .handleAction(taskFiltersActions.setDirections, payloadReducer)
        .handleAction(taskFiltersActions.clearFilters, () =>[]),
    client: createReducer<ClientWithBrands[]>([])
        .handleAction(taskFiltersActions.setClients, payloadReducer)
        .handleAction(taskFiltersActions.clearFilters, () =>[]),
    brand: createReducer<Brand[]>([])
        .handleAction(taskFiltersActions.setBrands, payloadReducer)
        .handleAction(taskFiltersActions.clearFilters, () =>[]),
    work_object: createReducer<WorkObject[]>([])
        .handleAction(taskFiltersActions.setWorkObjects, payloadReducer)
        .handleAction(taskFiltersActions.clearFilters, () => []),
    tasks_type: createReducer<TaskType[]>([])
        .handleAction(taskFiltersActions.setTasksType, payloadReducer)
        .handleAction(taskFiltersActions.clearFilters, () =>[]),
})